<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Secrets and Lies</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<p class="dedication"><em>Welcome</em><br/><em>Dallas O’Connor</em><br/><em>Latest and much loved addition to my family.</em><br/><em>Arrived on earth</em><br/><em>June 2011</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?d09bd926